/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.

import classnames from 'classnames'


import * as DateHelpers from 'utils/DateHelpers'
import ToolTipOnHover from 'components/shared/ToolTipOnHover'

import PropTypes from 'prop-types'

import 'styles/components/customer/CustomerMetric.styl'

const CustomerMetric = React.createClass({
  propTypes: {
    metric: PropTypes.node.isRequired,
    display: PropTypes.node.isRequired,
    showDelta: PropTypes.bool,
    deltaPercentage: PropTypes.node,
    selectable: PropTypes.bool,
    isSelected: PropTypes.bool,
    tooltipText: PropTypes.node,
    className: PropTypes.string
  },

  getDefaultProps() {
    return {
      selectable: false,
      isSelected: false,
      showDelta: false
    }
  },

  renderDelta() {
    const delta = this.props.deltaPercentage

    if (delta != null) {
      return (
        <div className="delta">
          <ToolTipOnHover toolTip={this.props.tooltipText}>
            <div
              className={classnames({
                'arrow': this.props.showDelta && (delta !== 0),
                'increasing': (delta > 0) || (delta === DateHelpers.NO_DELTA_CHANGE),
                'decreasing': delta < 0
              })} />
            <div className="percent">
              {`${ delta === DateHelpers.NO_DELTA_CHANGE ? DateHelpers.NO_DELTA_CHANGE : Math.abs(delta) }`}
              {delta !== DateHelpers.NO_DELTA_CHANGE ? '%' : undefined}
            </div>
          </ToolTipOnHover>
        </div>
      )
    }
  },

  render() {
    return (
      <div
        className={`CustomerMetric ${ this.props.className ? this.props.className : undefined }`}>
        <div
          className={classnames('container', {
            selectable: this.props.selectable,
            isSelected: this.props.isSelected
          })}>
          <div>
            <div className="value">
              {this.props.metric}
            </div>
            <div className="display">
              {this.props.display}
              {this.renderDelta()}
            </div>
          </div>
        </div>
      </div>
    )
  }
})

export default CustomerMetric



// WEBPACK FOOTER //
// ./src/scripts/components/customer/CustomerMetric.js